<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.data_scopes')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.datascope.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.datascope.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table
        [value]="scopes"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="data-scope-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
          <tr>
              <th pSortableColumn="translated_title" aria-label="{{ t('common.labels.title') }}">{{ t('common.labels.title') }}
                  <p-sortIcon field="translated_title"></p-sortIcon>
              </th>
              <th pSortableColumn="name" aria-label="{{ t('common.labels.name') }}">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="active" aria-label="{{ t('common.labels.active') }}">{{ t('common.labels.active') }}
                  <p-sortIcon field="active"></p-sortIcon>
              </th>
              <th>{{ t('common.labels.dimensions') }}</th>
          </tr>
          <tr class="filter">
            <th></th>
            <th>
              <p-columnFilter type="text" field="name" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th></th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-scope>
          <tr (click)="onOpen(scope)" (keyup.enter)="onOpen(scope)" hoverOnRight="admin.datascope.show" tabindex="0">
            <td><span role="link" [attr.aria-label]="scope.name">{{ scope.translated_title }}</span></td>
            <td><span role="link">{{ scope.name }}</span></td>
            <td>{{ scope.active === true ? t('common.labels.yes') : t('common.labels.no') }}</td>
            <td>{{ getDimensionsLabel(scope) }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
